import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/PuertaMoria.jpg'


const _withScopeId = n => (_pushScopeId("data-v-5c6204b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center pa-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "success-image",
  src: _imports_0,
  alt: "Di amigo y entra"
}, null, -1))

import {
  ref,
  watch,
  onMounted,
  onUnmounted,
} from "vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResponseLogin',
  props: {
  isVisible: {
    type: Boolean,
    required: true,
  },
},
  emits: ["update:isVisible"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;
const internalVisible = ref(props.isVisible);
const mellonButton = ref<HTMLButtonElement | null>(null);
const router = useRouter();

watch(
  () => props.isVisible,
  (newVal) => {
    internalVisible.value = newVal;

    // Enfocar el botón cuando se hace visible el modal
    if (newVal) {
      setTimeout(() => {
        if (mellonButton.value?.el) {
          mellonButton.value.$el.focus();
        }
      }, 0);
    }
  }
);

const handlerOk = () => {
  emits("update:isVisible", false);
  internalVisible.value = false;
  router.push({ name: "home" });
};

const handleKeyDown = (event: KeyboardEvent) => {
  if (event.key === "Enter") {
    handlerOk(); // Ejecutar el handler del botón "Mellon"
  }
};

onMounted(() => {
  window.addEventListener("keydown", handleKeyDown); // Escuchar el evento de teclado
  if (internalVisible.value) {
    setTimeout(() => {
      if (mellonButton.value?.$el) {
        mellonButton.value.$el.focus();
      }
    }, 0); // Enfocar el botón al cargar
  }
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleKeyDown); // Limpiar el evento al desmontar
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_dialog, {
          modelValue: internalVisible.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalVisible).value = $event)),
          width: "auto",
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              "max-width": "400",
              class: "dialog-card"
            }, {
              actions: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  ref_key: "mellonButton",
                  ref: mellonButton,
                  color: "blue darken-1",
                  variant: "tonal",
                  onClick: handlerOk,
                  class: "mx-auto"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Mellon ")
                  ]),
                  _: 1
                }, 512)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "text-center" }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }))
}
}

})